import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getMiniIfaAsync, getBomAndChartAsync,getShouldCostModelDetailsAsync } from 'src/services/costModelling/shouldCostLibrary.services'

const initialState = {
    modelDetailsLoader: false,
    modelDetailsData: [],
    modelDetailsError: '',
}

export const getModelDetailsDataSlice = createSlice({
    name: 'get-models-details-data',
    initialState,
    extraReducers: (builder) => {
        builder.addMatcher(isAnyOf(getMiniIfaAsync.pending), (state) => {
            state.modelDetailsLoader = true
        })
        builder.addMatcher(isAnyOf(getMiniIfaAsync.fulfilled), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsData = { ...state.modelDetailsData, ...action.payload.data }
            state.commodityLastUpdatedDate = action.payload.last_updated_date
        })
        builder.addMatcher(isAnyOf(getMiniIfaAsync.rejected), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsError = action.payload.message
        })

        builder.addMatcher(isAnyOf(getBomAndChartAsync.pending), (state) => {
            state.modelDetailsLoader = true
        })
        builder.addMatcher(isAnyOf(getBomAndChartAsync.fulfilled), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsData = { ...state.modelDetailsData, ...action.payload.data }
            state.commodityLastUpdatedDate = action.payload.last_updated_date
        })
        builder.addMatcher(isAnyOf(getBomAndChartAsync.rejected), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsError = action.payload.message
        })
        builder.addMatcher(isAnyOf(getShouldCostModelDetailsAsync.pending), (state) => {
            state.modelDetailsLoader = true
        })
        builder.addMatcher(isAnyOf(getShouldCostModelDetailsAsync.fulfilled), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsData = { ...state.modelDetailsData, ...action.payload.data}
            state.commodityLastUpdatedDate = action.payload.last_updated_date
        })
        builder.addMatcher(isAnyOf(getShouldCostModelDetailsAsync.rejected), (state, action) => {
            state.modelDetailsLoader = false
            state.modelDetailsError = action.payload.message
        })
    },
    reducers: {
        resetModelDetailsDataSlice: () => initialState,
    },
})

export const { resetModelDetailsDataSlice } = getModelDetailsDataSlice.actions

export default getModelDetailsDataSlice.reducer
